export const sortShopItems = (shopItems) => {
    return shopItems.sort((a, b) => {
        const aOutOfStock = (a.reward?.qtyMax - a.reward?.qtyUsed) <= 0;
        const bOutOfStock = (b.reward?.qtyMax - b.reward?.qtyUsed) <= 0;

        if (aOutOfStock && !bOutOfStock) return 1;
        if (!aOutOfStock && bOutOfStock) return -1;
        return 0;
    });
};